import { Centred, Contents } from '../../styles/mixins'

const styles = theme => ({
  contents: {
    ...Contents(theme),
  },
  centred: {
    ...Centred(theme),
  },
  enquiry: {
    marginTop: theme.spacing.unit * 5,
    marginBottom: theme.spacing.unit * 10,
  },
  feedbackFormSubmit: {
    marginTop: theme.spacing.unit * 5,
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/enquiry/styles.js